import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b70a26d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "invest-tabel" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "invest-tabel-title" }, "会员行业会议报名", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("编辑")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")

import { defineComponent } from "vue";
import store from "@/store/index";
import { useStore } from "@/store/index";
import { ref, reactive , watch} from "vue";
import { ElButton, ElMessage, ElMessageBox } from "element-plus";
import type { ElForm, Action } from "element-plus";
import Bottom from '../components/bottom.vue'
import { MoreFilled } from '@element-plus/icons-vue'

import tool from "@/utils/tool";
import router from "@/router/index";
import { Plus } from '@element-plus/icons-vue'
import type { UploadFile, ElFile } from 'element-plus/es/components/upload/src/upload.type'

type FormInstance = InstanceType<typeof ElForm>;

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const radio1 = ref('1')
const active = 0;
const activitiesStep = [
  {
    content: '报名',
    timestamp: '2018-04-12 20:46',
    size: 'large',
    type: 'primary',
    icon: MoreFilled,
  },
  {
    content: '缴费',
    timestamp: '2018-04-03 20:46',
    color: '#0bbd87',
  },
  {
    content: '成功',
    timestamp: '2018-04-03 20:46',
    size: 'large',
  },
];

const isDisabled = ref(false);

var id = router.currentRoute.value.params.id;
if (typeof id == "string") {
  store.dispatch("frontIndustryModule/getActivityApply", { activityId: id }).then(
    (data) => {
      //成功
      if (data.result != null) {
        bindData.activityApplyForm = data.result;
        isDisabled.value = true;
      }
    },
    (error) => {
      console.log(error.msg);
    }
  );
}

// store.dispatch("frontInvestModule/listJoinCategory", {}).then(
//   (data) => {
//     //成功
//     if (data.result != null) {
//       bindData.joinCategoryList = data.result;
//     }
//   },
//   (error) => {
//     console.log(error.msg);
//   }
// );

const activityApplyFormRef = ref<FormInstance>();

const ustore = useStore();

const bindData = reactive({
  memberName: '',
  joinCategoryList: [],
  activityApplyForm: {
    id: "",
    activityId: '',
    contact: '',
    mobile: '',
    identityCardNo: '',
    explanation: '',
    joinCategoryIds: '',
    identityCardPhoto: "",
    identityCardPhotoUrl: "",
    job: "",
    projectNumber: 0,
    turnover: '',
    brandName: '',
    companyName: '',
    sex: 1,
    cost: 0.00,
    isPayed:"N",
  }
});

if (typeof id == "string") {
  bindData.activityApplyForm.activityId = id;
}

bindData.memberName = ustore.state.loginMember == undefined ? '' : ustore.state.loginMember.companyName

watch(
  () => ustore.state.loginMember,
  (newValue: any, oldValue: any) => {
    bindData.memberName = newValue.companyName;
    bindData.activityApplyForm.contact = newValue.name;
    bindData.activityApplyForm.mobile = newValue.mobile;
  }
);

const defaultValidate = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("请填写联系人"));
  } else {
    callback();
  }
};

const activityApplyRules = reactive({
  contact: [{ required: true, validator: defaultValidate, trigger: "blur" }],
  mobile: [{ required: true, message: '请填写电话', trigger: "blur" }],
});

const submitForm = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate((valid) => {
    if (valid) {
      store.dispatch("frontIndustryModule/saveActivityApply", bindData.activityApplyForm).then(
        (data) => {
          //成功
          ElMessage.success("保存成功.");
          isDisabled.value = true;
          if (bindData.activityApplyForm.cost >= 0.01 && bindData.activityApplyForm.isPayed=="N") {
            router.push("/frontDesk/applyPayment/" + bindData.activityApplyForm.activityId);
          }
          else {
            router.push("/frontDesk/applySuccess/" + bindData.activityApplyForm.activityId);
          }
        },
        (error) => {
          ElMessageBox.alert(error.msg, "系统消息", {
            confirmButtonText: "关闭",
            callback: (action: Action) => { },
          });
        }
      );
    } else {
      console.log("error submit!");
      return false;
    }
  });
};

const beforeUploadCheckEvent = (file: ElFile) => {
  let types = ["image/jpeg", "image/gif", "image/bmp", "image/png"];
  const isImage = types.includes(file.type);
  const isLt2M = file.size / 1024 / 1024 < 2;

  if (!isImage) {
    ElMessage.error("上传的图片必须是JPG,GIF,BMP,PNG格式!");
  }
  if (!isLt2M) {
    ElMessage.error("上传的图片文件大小不能超过2MB!");
  }
  return isImage && isLt2M;
};

const handleEdit = () => {
  isDisabled.value = false;
};

const handleCardFrontFileSuccess = (
  response: any,
  file: UploadFile,
  fileList: UploadFile[]
) => {
  bindData.activityApplyForm.identityCardPhoto = response.result;
  bindData.activityApplyForm.identityCardPhotoUrl = URL.createObjectURL(file.raw);
};

const resetForm = (formEl: FormInstance | undefined) => {
  console.log("exec...resetForm");
  if (!formEl) return;
  formEl.resetFields();
};


return (_ctx: any,_cache: any) => {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_container = _resolveComponent("el-container")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createVNode(_component_el_steps, {
        active: active,
        "finish-status": "success"
      }, {
        default: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(activitiesStep, (activityStep, index) => {
            return _createVNode(_component_el_step, {
              key: index,
              title: activityStep.content
            }, null, 8, ["title"])
          }), 64))
        ]),
        _: 1
      }),
      _createVNode(_component_el_form, {
        class: "invest-tabel-ct",
        model: _unref(bindData).activityApplyForm,
        ref_key: "activityApplyFormRef",
        ref: activityApplyFormRef,
        "label-width": "200px",
        "status-icon": "",
        rules: _unref(activityApplyRules)
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, { label: "会员信息" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).memberName,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(bindData).memberName) = $event)),
                prop: "memberName",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: true
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "姓名" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.contact,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(bindData).activityApplyForm.contact) = $event)),
                prop: "contact",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "公司职务" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.job,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(bindData).activityApplyForm.job) = $event)),
                prop: "job",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "电话" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _unref(bindData).activityApplyForm.mobile,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(bindData).activityApplyForm.mobile) = $event)),
                prop: "mobile",
                "input-style": "width:300px",
                placeholder: "",
                size: "default",
                disabled: isDisabled.value
              }, null, 8, ["modelValue", "disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"]),
      _createVNode(_component_el_container, { class: "invest-tabel-btn" }, {
        default: _withCtx(() => [
          (isDisabled.value)
            ? (_openBlock(), _createBlock(_unref(ElButton), {
                key: 0,
                type: "info",
                size: "large",
                onClick: handleEdit
              }, {
                default: _withCtx(() => [
                  _hoisted_3
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_unref(ElButton), {
                key: 1,
                type: "primary",
                size: "large",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (submitForm(activityApplyFormRef.value)))
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }))
        ]),
        _: 1
      })
    ]),
    _createVNode(Bottom)
  ]))
}
}

})